export function deriveImageAllowance(entitlements) {
  const allowance = entitlements?.usage?.image_generations_monthly;
  if (allowance?.limit === null) return { known: true, limit: null, zero: false };
  if (!allowance || typeof allowance.limit !== 'number' || !Number.isFinite(allowance.limit) || allowance.limit < 0) {
    return { known: false, limit: null, zero: false };
  }
  return { known: true, limit: allowance.limit, zero: allowance.limit === 0 };
}
